import { queryClient } from "./queryClient";
import { queryKeys } from "./keys";

/** Інвалідувати кеш credits (після покупки / зміни підписки). */
export function invalidateCreditsQuery() {
  return queryClient.invalidateQueries({ queryKey: queryKeys.credits });
}
